import { NEXT_AVAILABLE_TIME } from "./TimeType";

export const setNextAvailableTime = (payload) => {
    return {
        type: NEXT_AVAILABLE_TIME,
        payload: payload,
    };
};